const INPUT_LENTTHS = {
  MAXIMUM_175: 175,
} as const;

export default INPUT_LENTTHS;
